(function ($) {

    $(document).ready(function () {

        if ($('.col-with-video .slider-outer').length > 0) {
            setTimeout(function () {
                $(".col-with-video").css({"opacity": "1"});
            }, 500);

            $('.col-with-video .slider-outer ').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
            });
        }
    });
})(jQuery);